import React, { Component } from 'react'
import { Icon } from '@drifthq/tide-core'
import { goBack } from 'react-router-redux'
import { bindActionCreators } from "redux"
import { connect } from 'react-redux'

import './style.css'

class BackButton extends Component {
  render() {
    return (
      <div className="onboarding-back-button" onClick={() => this.props.actions.pop()}>
        <Icon name="arrow-1-left" className="onboarding-back-button-caret" />
        Back
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    pop: goBack,
  }, dispatch)
})


export default connect(null, mapDispatchToProps)(BackButton)


// WEBPACK FOOTER //
// ./src/components/OnboardingBackButton/index.js